import { concat } from 'lodash';
import { PERMISSIONS_SUBSCRIBED_PLAN } from 'constants/permissions';

import { SCOPES } from 'constants/roles';

import PersonParticipant from './navigation-person-participant';
import PersonMyTeam from './navigation-person-my-team';
import PersonInvitation from './navigation-person-invitation';

export default {
  label: 'label.persons',
  name: 'participants-list',
  type: 'section',
  url: '/professional/persons',
  navigationIcon: 'far fa-users',
  scope: SCOPES.INSTANCE_STAFF,
  requiredSubscribedFeature: [
    PERMISSIONS_SUBSCRIBED_PLAN.TEAM_MEMBERS,
    PERMISSIONS_SUBSCRIBED_PLAN.PARTICIPANTS,
  ],
  pages: concat(
    PersonParticipant,
    PersonMyTeam,
    PersonInvitation,
  ),
};



// WEBPACK FOOTER //
// ./src/data/navigations/person/index.js